module.exports = __webpack_public_path__ + "media/images/brand-assets/light_3-0e755dcf38f853784d6d7192d3df1929.png";